import { render, staticRenderFns } from "./GuardList.vue?vue&type=template&id=2dc7e69e&scoped=true&"
import script from "./GuardList.vue?vue&type=script&lang=js&"
export * from "./GuardList.vue?vue&type=script&lang=js&"
import style0 from "./GuardList.vue?vue&type=style&index=0&id=2dc7e69e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc7e69e",
  null
  
)

export default component.exports